const initialState= {
    VulnerabilityData: []
}

const fetchClientVulnerabilities=(state=initialState, action)=>{
    switch(action.type) {
        case 'SET_VULNERABILITY_LIST':
            return {
                ...state,
                VulnerabilityData: action.payload
            }
        default:
            return state
    }
}

export default fetchClientVulnerabilities
